/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ApiTokenDTO,
  ChangeEmailDTO,
  CopyEmailSettingsResult,
  ErrorResponse,
  LinkGenerationResponse,
  UserDTO,
  UserDisplayDTO,
  UserSettingKey,
  UserSettingsResponse,
  UserSettingsUpdateRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class UserApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Operators can change the email address of a non-privileged user. The new email is stored in lowercase. Admins and managing directors are excluded.
   *
   * @tags user-api
   * @name ChangeEmail
   * @summary Change user email address
   * @request POST:/api/users/{userId}/change-email
   * @secure
   */
  changeEmail = (
    userId: number,
    data: ChangeEmailDTO,
    params: RequestParams = {},
  ) =>
    this.request<UserDTO, ErrorResponse | UserDTO>({
      path: `/api/users/${userId}/change-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Copies all email-notification settings of the given user from the source company to all other companies in which the same user holds an active membership. Only the user themselves or an operator may invoke this endpoint. Returns the list of companies that were updated.
   *
   * @tags user-api
   * @name CopyEmailSettingsToOtherMemberships
   * @summary Copy email-notification settings to other memberships
   * @request POST:/api/users/{userId}/companies/{companyId}/email-settings/copy-to-other-memberships
   * @secure
   */
  copyEmailSettingsToOtherMemberships = (
    userId: number,
    companyId: number,
    params: RequestParams = {},
  ) =>
    this.request<
      CopyEmailSettingsResult,
      ErrorResponse | CopyEmailSettingsResult
    >({
      path: `/api/users/${userId}/companies/${companyId}/email-settings/copy-to-other-memberships`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-api
   * @name CreateApiToken
   * @summary This API creates an API token for a user. An old token gets invalidated.
   * @request POST:/api/users/create-api-token
   * @secure
   */
  createApiToken = (params: RequestParams = {}) =>
    this.request<ApiTokenDTO, ErrorResponse>({
      path: `/api/users/create-api-token`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Company managers and admins can delete users. The membership is deactivated and the contact person role is reassigned if needed. Users cannot delete themselves or the managing director.
   *
   * @tags user-api
   * @name DeleteUser
   * @summary Delete a user from the company
   * @request DELETE:/api/users/{companyId}/{userId}
   * @secure
   */
  deleteUser = (
    companyId: number,
    userId: number,
    query?: {
      /** @format int64 */
      reassignedUserId?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<UserDisplayDTO[], ErrorResponse | UserDisplayDTO[]>({
      path: `/api/users/${companyId}/${userId}`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Generates a new password reset link for a user who has at least one CONFIRMED membership. All previous PASSWORD_RESET tokens for the user are invalidated. No email is sent — the link is returned in the response for the operator to share manually. Only accessible by operators.
   *
   * @tags user-api
   * @name GeneratePasswordResetLink
   * @summary Generate a password reset link for a user
   * @request POST:/api/users/{userId}/generate-password-reset-link
   * @secure
   */
  generatePasswordResetLink = (userId: number, params: RequestParams = {}) =>
    this.request<
      LinkGenerationResponse,
      ErrorResponse | LinkGenerationResponse
    >({
      path: `/api/users/${userId}/generate-password-reset-link`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Generates a new signup link for a user membership that is in INVITED status. All previous USER_SIGNUP tokens for the user+company combination are invalidated. No email is sent — the link is returned in the response for the operator to share manually. Only accessible by operators.
   *
   * @tags user-api
   * @name GenerateUserSignupLink
   * @summary Generate a user signup link for a specific membership
   * @request POST:/api/users/{userId}/memberships/{membershipId}/generate-signup-link
   * @secure
   */
  generateUserSignupLink = (
    userId: number,
    membershipId: number,
    params: RequestParams = {},
  ) =>
    this.request<
      LinkGenerationResponse,
      ErrorResponse | LinkGenerationResponse
    >({
      path: `/api/users/${userId}/memberships/${membershipId}/generate-signup-link`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-api
   * @name GetActiveCompanyUsers
   * @summary get active users of current company
   * @request GET:/api/users/active-company-users
   * @secure
   */
  getActiveCompanyUsers = (params: RequestParams = {}) =>
    this.request<UserDisplayDTO[], ErrorResponse | UserDisplayDTO[]>({
      path: `/api/users/active-company-users`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieves the effective email-notification settings of the specified user for the given company. Settings of other categories, such as the stored table view state, are not part of this response. Only the user themselves or an operator can access these settings. Unauthorized access will result in an error.
   *
   * @tags user-api
   * @name GetAllSettings
   * @summary Returns the email-notification settings of a user
   * @request GET:/api/users/{id}/companies/{companyId}/settings
   * @secure
   */
  getAllSettings = (
    id: number,
    companyId: number,
    params: RequestParams = {},
  ) =>
    this.request<
      UserSettingsResponse,
      void | ErrorResponse | UserSettingsResponse
    >({
      path: `/api/users/${id}/companies/${companyId}/settings`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description You can only read user of your company
   *
   * @tags user-api
   * @name GetUser
   * @summary Load user
   * @request GET:/api/users/{companyId}/{userId}
   * @secure
   */
  getUser = (companyId: number, userId: number, params: RequestParams = {}) =>
    this.request<UserDTO, ErrorResponse | UserDTO>({
      path: `/api/users/${companyId}/${userId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Allows the authenticated user or an operator to save or update the email-notification settings of the specified user. Keys of other categories, such as the table view state, are rejected. Only authorized users can perform this operation. Unauthorized access will result in an error.
   *
   * @tags user-api
   * @name PutAll
   * @summary Save or update the email-notification settings of a user
   * @request PUT:/api/users/{id}/companies/{companyId}/settings
   * @secure
   */
  putAll = (
    id: number,
    companyId: number,
    data: UserSettingsUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, void | ErrorResponse>({
      path: `/api/users/${id}/companies/${companyId}/settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Allows the authenticated user or an operator to save or update one email-notification setting of the specified user. Keys of other categories, such as the table view state, are rejected. Only authorized users can perform this operation. Unauthorized access will result in an error.
   *
   * @tags user-api
   * @name PutSingle
   * @summary Save or update a single email-notification setting for a user
   * @request PUT:/api/users/{id}/companies/{companyId}/settings/{key}
   * @secure
   */
  putSingle = (
    id: number,
    companyId: number,
    key: UserSettingKey,
    data: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void | ErrorResponse>({
      path: `/api/users/${id}/companies/${companyId}/settings/${key}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Resends the signup invitation email to a user with INVITED membership status. Admin can resend for any company. CLIENT_MANAGING_DIRECTOR can only resend for their own company.
   *
   * @tags user-api
   * @name ResendUserInvitation
   * @summary Resend user invitation
   * @request POST:/api/users/{userId}/resend-invitation/{companyId}
   * @secure
   */
  resendUserInvitation = (
    userId: number,
    companyId: number,
    params: RequestParams = {},
  ) =>
    this.request<void, ErrorResponse | void>({
      path: `/api/users/${userId}/resend-invitation/${companyId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Only the user it self can save it's data
   *
   * @tags user-api
   * @name SaveUser
   * @summary save user
   * @request PUT:/api/users/{id}
   * @secure
   */
  saveUser = (id: number, data: UserDTO, params: RequestParams = {}) =>
    this.request<UserDTO, ErrorResponse | UserDTO>({
      path: `/api/users/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Sends a password reset email to an active user. Available for operators and company members with access.
   *
   * @tags user-api
   * @name TriggerPasswordReset
   * @summary Trigger password reset for user
   * @request POST:/api/users/{id}/password-reset
   * @secure
   */
  triggerPasswordReset = (id: number, params: RequestParams = {}) =>
    this.request<void, ErrorResponse | void>({
      path: `/api/users/${id}/password-reset`,
      method: "POST",
      secure: true,
      ...params,
    });
}
